import store from "@/store";
import { updateTitle } from "@/utils/titleUpdater";
import FinanceiroView from "@/views/FinanceiroView.vue";
import adminRouter from "@/views/admin/router";
import Vue from "vue";
import VueGtag from "vue-gtag";
import VueRouter, { RouteConfig } from "vue-router";
import BuscaPedidosView from "../views/BuscaPedidosView.vue";
import BuscaProdutosView from "../views/BuscaProdutosView.vue";
import CheckoutView from "../views/CheckoutView.vue";
import CustomPageView from "../views/CustomPage.vue";
import DetalhesPedidoView from "../views/DetalhesPedidoView.vue";
import Home from "../views/Home.vue";
import NotFoundView from "../views/NotFoundView.vue";
import PoliticaPrivacidadeView from "../views/politicaPrivacidade.vue";


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/home",
        alias: "/",
        name: "Home",
        component: Home,
        props: router => ({
            page: router.query.page,
            itemsPerPage: router.query.itemsPerPage,
            sortId: router.query.sortId,
        })
    },
    {
        path: "/paginas/:name",
        name: "PaginaCustom",
        component: CustomPageView,
        props: true
    },
    {
        path: "/produtos",
        name: "Produtos",
        component: BuscaProdutosView,
        props: router => ({
            sortId: router.query.sortId,
            grupo: router.query.grupo,
            subgrupo: router.query.subgrupo,
            familia: router.query.familia,
            marca: router.query.marca,
            prodSearch: router.query.prodSearch,
            page: router.query.page,
            itemsPerPage: router.query.itemsPerPage,
            grupoProdutos: router.query.grupoProdutos,
        })
    },
    {
        path: "/checkout",
        name: "Checkout",
        component: CheckoutView
    },
    {
        path: "/pedidos",
        name: "Pedidos",
        component: BuscaPedidosView
    },
    {
        path: "/pedido/:nroPedido",
        name: "Visualizar Pedido",
        component: DetalhesPedidoView
    },
    {
        path: "/politica-de-privacidade",
        name: "Política de Privacidade",
        component: PoliticaPrivacidadeView,
    },
    {
        path: "*",
        name: "Página não encontrada",
        component: NotFoundView
    },
    {
        path: "/financeiro",
        name: "Financeiro",
        component: FinanceiroView
    },
    ...adminRouter
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

Vue.use(VueGtag, {
    // config: { id: "G-5XKYT6FE4E" }
    bootstrap: false
}, router);

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const requiresAdm = to.matched.some((record) => record.meta.requiresAdmin);

    if (requiresAuth) {
        const loggedIn = store.getters["Auth/isLoggedIn"];
        return loggedIn ? next() : next("/");
    }

    if (requiresAdm) {
        const isAdmin = await store.getters("Auth/isUserAdmin");
        return isAdmin ? next() : next("/");
    }

    Vue.nextTick(() => {
        updateTitle(to.name || "");
    });


    next();
});




export default router;
